import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import ConfirmationModal from './ConfirmationModal';

class DeleteButton extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showConfirmModal: false,
            disableSubmit: true
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCheckboxToggle = this.onCheckboxToggle.bind(this);
    }

    onDelete() {
        this.props.onDelete();
    }

    toggleModal(): void {
        let newValue = !this.state.showConfirmModal;

        if (this.props.onToggleOn) {
            this.props.onToggleOn(function () {
                this.setState({
                    showConfirmModal: newValue,
                    disableSubmit: newValue
                });
            });
        } else {
            this.setState({
                showConfirmModal: newValue,
                disableSubmit: newValue
            });
        }
    }

    onCheckboxToggle(e: any): void {
        this.setState({ disableSubmit: !this.state.disableSubmit });
    }

    render(): any {
        let attributes: any;
        if (this.props.extraValidation) {
            attributes = {
                extraValidation: true,
                extraValidationText: this.props.extraValidationText
            };
        } else {
            attributes = {
                extraValidation: false,
                extraValidationText: ''
            };
        }

        return (
            <Button
                disabled={this.props.disabled}
                bsStyle="danger"
                onClick={() => this.toggleModal()}
            >
                <i className="material-icons">delete</i>
                {Translate('delete/button-label/delete')}

                {this.state.showConfirmModal && (
                    <ConfirmationModal
                        {...attributes}
                        closeModal={this.toggleModal}
                        title={Translate('delete/modal/title/delete')}
                        text={this.props.text}
                        doButtonLabel={Translate('delete/modal/footer/button-label/delete')}
                        cancelButtonLabel={Translate('delete/modal/footer/button-label/cancel')}
                        doButtonStyle="danger"
                        do={this.onDelete}
                        disableSubmit={this.state.disableSubmit}
                        initialSubmitDisabling={this.props.extraValidation}
                        onCheckboxToggle={this.onCheckboxToggle}
                    />
                )}
            </Button>
        );
    }
}

export default DeleteButton;
